import { render, staticRenderFns } from "./AddEdtAssetDlg.vue?vue&type=template&id=0284670e"
import script from "./AddEdtAssetDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtAssetDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports